<template>
  <b-dropdown
    class="filter-dropdown"
    variant="outline-secondary"
    menu-class="menu-shadow scrollable text-medium"
    toggle-class="rounded-pill filter-toggle-field"
  >
    <template slot="button-content">
      <span class="d-flex overflow-hidden align-items-center text-medium ">
        <span class="filter-label"
          >{{ label }}<span :id="'info-' + uuid" v-if="hasInfo">(?)</span>:
        </span>
        <span class="filter-value text-truncate ml-1">
          <span :title="selected">{{ selected }}</span>
        </span>
        <b-popover
          :target="'info-' + uuid"
          triggers="hover"
          placement="bottom"
          custom-class="text-medium"
          v-if="hasInfo"
        >
          {{ info }}
          <slot name="info"></slot>
        </b-popover>
      </span>
    </template>
    <b-dropdown-item v-for="option in options" @click="$emit('change', option.id)" :key="option.id">
      <div class="d-flex align-items-center">
        <i class="mr-2" :class="option.icon" v-if="option.icon"></i>
        {{ option.label }}
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import ComponentIdMixin from '@/mixins/ComponentIdMixin'
import { BDropdownItem, BDropdown, BPopover } from 'bootstrap-vue'

/**
 * This component is a wrapper over bootstrap dropdown. It has been styled in a way how we show dropdowns in filter section (on All Goals, All Activity, All Initiatives page)
 *
 * slots
 *  - info: information to show in tooltip
 */
export default {
  name: 'FilterDropdown',
  props: {
    /**
     * Array of object containing {id, label}
     */
    options: Array,
    /**
     * Selected value to be shown
     */
    selected: [String, Number],
    label: String,
    info: String
  },
  mixins: [ComponentIdMixin],
  computed: {
    hasInfo() {
      return this.info || this.$slots.info
    }
  },
  components: {
    BDropdownItem,
    BDropdown,
    BPopover
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

/deep/ .filter-toggle-field {
  border-color: transparent;
  background: $quinary !important;
  color: inherit !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 10px;
}

.filter-dropdown {
  white-space: nowrap;
}

.filter-value {
  padding: 2px 10px;
  background: $quaternary;
  border-radius: 20px;
}

.filter-label {
  align-self: center;
  padding-right: 8px;
  line-height: 1;
}

@include media-breakpoint-down(md) {
  .filter-dropdown {
    flex-grow: 0;
  }
  .activity-filter-wrapper {
    justify-content: flex-start !important;
  }
}

@include media-breakpoint-down(sm) {
  .filter-dropdown {
    flex-basis: 100%;
  }
  /deep/ .filter-toggle-field {
    max-width: initial;
    width: 100%;
  }
}
</style>
